import { supabase } from '@/integrations/supabase/client';

// Admins can read every profile in their org, so "my profile" queries must filter on this.
export async function currentUserId(): Promise<string> {
  const { data } = await supabase.auth.getSession();
  return data.session?.user.id ?? '';
}
